import { createContext, useContext, useState, useCallback } from "react";

const InquiryDialogContext = createContext(null);

export function InquiryDialogProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [defaultPropertyType, setDefaultPropertyType] = useState(null);

  const openDialog = useCallback((propertyType = null) => {
    setDefaultPropertyType(propertyType);
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => setOpen(false), []);

  return (
    <InquiryDialogContext.Provider value={{ open, setOpen, openDialog, closeDialog, defaultPropertyType }}>
      {children}
    </InquiryDialogContext.Provider>
  );
}

export function useInquiryDialog() {
  const ctx = useContext(InquiryDialogContext);
  if (!ctx) throw new Error("useInquiryDialog must be used within InquiryDialogProvider");
  return ctx;
}
